import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, includes } from "lodash";
import { Link } from "react-router-dom";

import Grid from "@material-ui/core/Grid";

import { isUnknownProfile, getAttributeValue } from "../../utils/profile";

import { human, driver, truck, trailer } from "../../constants/common";

import images from "../../assets/img/images";
import colors from "../../assets/style/colors";

const styles = {
  link: {
    color: colors.primary,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "1.13em",
    "& span": {
      colors: colors.black87,
    },
  },
};

const ProfileLink = (props) => {
  const {
    classes,
    profile,
    score,
    overriden,
    onlyLink,
    // noTitle,
    containerStyle,
    myprofile
  } = props;

  return (
    <Grid
      item
      xs
      className={!containerStyle ? classes.container : ""}
      style={containerStyle ? containerStyle : {}}
    >
      {!onlyLink &&
        (includes([1, 2, 3, 4, 5], get(profile, ["type", "id"])) ||
          includes([human, driver, truck, trailer], props.type)) && (
          <>
            {/* {!noTitle && (
            <span className="bold-500">{I18n.get("site_profile")}:</span>
          )} */}
            <img
              style={{ margin: "0px 12px", maxWidth: "35px" }}
              src={
                get(profile, ["type", "id"]) === 1 ||
                props.type === human ||
                props.type === driver
                  ? images.humanIconBlack
                  : get(profile, ["type", "id"]) === 2 || props.type === truck
                  ? images.truckIconBlack
                  : get(profile, ["type", "id"]) === 3 || props.type === trailer
                  ? images.trailerIconBlack
                  : get(profile, ["type", "id"]) === 4
                  ? images.containerIconBlack
                  : get(profile, ["type", "id"]) === 5
                  ? images.paletteIconBlack
                  : ""
              }
              alt="profile_icon"
              height="18px"
            />
          </>
        )}
      {get(profile, ["id"]) && !isUnknownProfile(get(profile, ["id"])) ? (
        <>
          {props.disabled ? (
            <span>
              {get(profile, ["type", "id"]) === 1
                ? `${getAttributeValue(profile, 31)} ${getAttributeValue(
                    profile,
                    32
                  )}`
                : getAttributeValue(profile, 18)}
            </span>
          ) : (
            <Link
              to={get(profile, ["id"]) === myprofile ? "/profiles/me" : `/profiles/${get(profile, ["id"])}`}
              className={classes.link}
              onClick={(e) => e.stopPropagation()}
            >
              <span>
                {get(profile, ["type", "id"]) === 1
                  ? `${getAttributeValue(profile, 31)} ${getAttributeValue(
                      profile,
                      32
                    )}`
                  : getAttributeValue(profile, 18)}
              </span>
            </Link>
          )}
          {score && (
            <span style={{ margin: "0px 5px" }}>
              {`(${Math.round(parseFloat(score) * 100)}%)`}
            </span>
          )}
          {overriden && (
            <span>
              <img src={images.overrideIconBlack} alt="overriden" />
            </span>
          )}
        </>
      ) : (
        <span>{I18n.get("site_unknown")}</span>
      )}
    </Grid>
  );
};

ProfileLink.propTypes = {
  profile: PropTypes.object,
  score: PropTypes.number,
  overriden: PropTypes.any,
  onlyLink: PropTypes.bool,
  noTitle: PropTypes.bool,
};

export default withStyles(styles)(ProfileLink);
